import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';

import { WizardStepsContainer } from 'presentation/components/WizardSteps';
import TitleWithPrevPageLink from 'presentation/components/TitleWithPrevPageLink';
import PageDescription from 'presentation/components/PageDescription';
import Icon, { ICONSIZE } from 'presentation/components/Icon';
import circledCheckmarkIcon from 'presentation/assets/icons/png/3x/circle-check-info@3x.png';
import SAFeatureView from 'presentation/components/SAFeatureView';
import ProgrammaticConversionTracking from 'presentation/components/ProgrammaticConversionTracking';
import {
  PROGRAMMATIC_CONVERSION_IMG_SRC,
  PROGRAMMATIC_CONVERSION_SCRIPT_SRC
} from 'tracking/programmaticTracking';

interface Props {}

const EndPage: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <Container className="pb-4 mb-5">
      <WizardStepsContainer />

      <TitleWithPrevPageLink title={t('pageSuccessTitle')} />

      <PageDescription>{t('pageSuccessDescription')}</PageDescription>

      <Row>
        <Col xs={12} className="my-3">
          <Icon iconSrc={circledCheckmarkIcon} size={ICONSIZE.xxlarge} alt="checkmark icon"></Icon>
        </Col>
      </Row>

      <SAFeatureView />

      <ProgrammaticConversionTracking
        programmaticConversionImgSrc={PROGRAMMATIC_CONVERSION_IMG_SRC}
        programmaticConversionScriptSrc={PROGRAMMATIC_CONVERSION_SCRIPT_SRC}
      />
    </Container>
  );
};

export default EndPage;
